var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBubblegumHighlighted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29476",
    "data-name": "Group 29476",
    transform: "translate(-220.999 -342.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(220.999 342.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-princess-bubblegum",
    transform: "translate(239.766 348.729)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50158",
    "data-name": "Path 50158",
    d: "M13,25v4.178h9.476V25Zm4.738,1.292a2.465,2.465,0,0,1-.935-.159,1.745,1.745,0,0,1,1.869,0A2.465,2.465,0,0,1,17.738,26.292Z",
    transform: "translate(-9.985 -15.093)",
    fill: "#880e4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50159",
    "data-name": "Path 50159",
    d: "M13,15.169c0,2.365,1.456,4.954,3.446,5.768a3.309,3.309,0,0,0,2.584,0c1.99-.814,3.446-3.4,3.446-5.768C22.476,12.314,13,12.314,13,15.169Zm4.738,3.877a1.612,1.612,0,0,1,.935.271,2.821,2.821,0,0,1-1.869,0A1.612,1.612,0,0,1,17.738,19.046Z",
    transform: "translate(-9.985 -8.277)",
    fill: "#ffcdd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50160",
    "data-name": "Path 50160",
    d: "M21,30h2.584v1.723H21Z",
    transform: "translate(-14.539 -17.939)",
    fill: "#ffcdd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50161",
    "data-name": "Path 50161",
    d: "M22.892,36.584v1.723H16V36.584L18.154,34h2.584Z",
    transform: "translate(-11.693 -20.216)",
    fill: "#f06292"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50162",
    "data-name": "Path 50162",
    d: "M21.507,14.615v7.753H17.2V12.461s0-1.292-3.446-1.292-3.446,1.292-3.446,1.292v9.907H6V14.615C6,8.705,9.877,6,13.753,6,18.061,6,21.507,8.705,21.507,14.615Z",
    transform: "translate(-6 -4.277)",
    fill: "#f06292"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50163",
    "data-name": "Path 50163",
    d: "M20.615,41h1.723v1.292H20.615ZM12,41h1.723v1.292H12Z",
    transform: "translate(-9.416 -24.201)",
    fill: "#ffcdd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50164",
    "data-name": "Path 50164",
    d: "M20.615,37.442v-.857c.9,0,.861-.431,1.723-.431v.861S22.381,37.386,20.615,37.442Zm-6.892-.857v.857C11.957,37.386,12,37.015,12,37.015v-.861C12.861,36.154,12.861,36.584,13.723,36.584ZM18.461,34H15.877l-1.129,1.353a1.856,1.856,0,0,0,1.129.37,1.822,1.822,0,0,0,1.292-.513,1.822,1.822,0,0,0,1.292.513,1.856,1.856,0,0,0,1.129-.37Z",
    transform: "translate(-9.415 -20.216)",
    fill: "#6a1b9a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28951",
    "data-name": "Group 28951",
    transform: "translate(2.584 13.353)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50165",
    "data-name": "Path 50165",
    d: "M22.338,35.584c-.861,0-.823.431-1.723.431l-1.981-2.378c.181-.375.655-.637,1.551-.637C22.338,33,22.338,33.861,22.338,35.584ZM15.7,33.637l-1.981,2.378c-.861,0-.861-.431-1.723-.431C12,33.861,12,33,14.154,33,15.05,33,15.523,33.263,15.7,33.637Z",
    transform: "translate(-12 -33)",
    fill: "#ec407a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50166",
    "data-name": "Path 50166",
    d: "M9.092,8.307a25.384,25.384,0,0,1,6.421-.861,27.263,27.263,0,0,1,6.529.861,3.824,3.824,0,0,0-.606-1.077c-.7-.557-2.375-.317-3.338-.646A5.12,5.12,0,0,1,15.513,4a5.335,5.335,0,0,1-2.584,2.584c-.959.336-2.64.088-3.338.646A2.968,2.968,0,0,0,9.092,8.307Z",
    transform: "translate(-7.76 -3.139)",
    fill: "#fbc02d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50167",
    "data-name": "Path 50167",
    d: "M23.146,2a.646.646,0,1,0,.646.646A.646.646,0,0,0,23.146,2Z",
    transform: "translate(-15.393 -2)",
    fill: "#4db6ac"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28952",
    "data-name": "Group 28952",
    transform: "translate(5.169 8.615)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50168",
    "data-name": "Path 50168",
    d: "M18.431,22a.431.431,0,1,0,.431.431A.431.431,0,0,0,18.431,22Zm4.307,0a.431.431,0,1,0,.431.431A.431.431,0,0,0,22.738,22Zm-.431,1.473a1.116,1.116,0,0,1-.788.952,1.745,1.745,0,0,0-1.869,0,1.116,1.116,0,0,1-.788-.952c0-.4.765,0,1.723,0S22.307,23.077,22.307,23.473Z",
    transform: "translate(-18 -22)",
    fill: "#212121"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50169",
    "data-name": "Path 50169",
    d: "M23.7,27.271a2.821,2.821,0,0,1-1.869,0,1.745,1.745,0,0,1,1.869,0Z",
    transform: "translate(-15.011 -16.231)",
    fill: "#e57373"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubblegumHighlighted);
export default __webpack_public_path__ + "static/media/bubblegumHighlighted.14eda93e501ad6500f58a945c204ad8f.svg";
export { ForwardRef as ReactComponent };